export default "__VITE_ASSET__9c85a9f2__"